import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { fetchForm, updateData } from '../actions/form';
import { fetchRequirements } from '../actions/requirements';
import { Accordion, Form } from 'semantic-ui-react';
import { isFetching } from '../reducers';
import General from './General';
import { fetchSites } from '../actions/sites';
import { fetchContacts } from '../actions/contacts';
import { fetchZoneTemplates } from '../actions/zoneTemplates';
import Zone from './Zone';
import StateOfPlay from './StateOfPlay';
import Recommendation from './Recommendation';
import Plannification from './Plannification';
import SitePlans from './SitePlans';
import AccessInformation from './AccessInformation';

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = { activeIndex: 0 };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, titleProps) {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }

  componentWillMount() {
    this.props.fetchRequirements(this.props.caseId);
    this.props.fetchForm(this.props.caseId);
    this.props.fetchSites(this.props.customerId);
    this.props.fetchContacts(this.props.customerId);
    this.props.fetchZoneTemplates(this.props.caseId);
  }

  render() {
    const isReadOnly = this.props.caseStatus === 'TRANSFERED';

    const panels = [
      {
        key: 'panel-1',
        title: 'Zone à protéger',
        content: { key: 'content-1', content: <Zone readOnly={isReadOnly} /> },
      },
      {
        key: 'panel-2',
        title: 'Etat des lieux',
        content: {
          key: 'content-2',
          content: <StateOfPlay readOnly={isReadOnly} />,
        },
      },
      {
        key: 'panel-3',
        title: 'Plans des lieux',
        content: {
          key: 'content-3',
          content: <SitePlans caseId={this.props.caseId} disabled />,
        },
      },
      {
        key: 'panel-4',
        title: 'Préconisations',
        content: {
          key: 'content-4',
          content: <Recommendation readOnly={isReadOnly} />,
        },
      },
    ];

    if (!this.props.isFetching) {
      return (
        <Form>
          <General customerId={this.props.customerId} readOnly={isReadOnly} />
          <AccessInformation readOnly={isReadOnly} />
          <h3>Etude</h3>
          {this.props.canPlan && <Plannification />}
          <Accordion styled fluid defaultActiveIndex={0} panels={panels} />
        </Form>
      );
    } else {
      return (
        <div
          className="ui active loading segment"
          style={{ minHeight: '180px' }}
        />
      );
    }
  }
}

Page.propTypes = {
  caseId: PropTypes.number.isRequired,
  customerId: PropTypes.number.isRequired,
  isFetching: PropTypes.bool.isRequired,
  fetchRequirements: PropTypes.func.isRequired,
  fetchForm: PropTypes.func.isRequired,
  fetchSites: PropTypes.func.isRequired,
  fetchContacts: PropTypes.func.isRequired,
  fetchZoneTemplates: PropTypes.func.isRequired,
  updateData: PropTypes.func.isRequired,
  canPlan: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: isFetching(state),
  canPlan: state.form.form.canPlan,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchRequirements: caseId => dispatch(fetchRequirements(caseId)),
  fetchForm: caseId => dispatch(fetchForm(caseId)),
  fetchSites: customerId => dispatch(fetchSites(customerId)),
  fetchContacts: customerId => dispatch(fetchContacts(customerId)),
  fetchZoneTemplates: caseId => dispatch(fetchZoneTemplates(caseId)),
  updateData: (siteId, propName, propValue) =>
    dispatch(updateData(siteId, propName, propValue)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/Page.js